"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable camelcase */
/**
 * Convenience class that extends the n3 store API that deletes
 * quads as they are extracted from the store
 */
const n3_1 = require("n3");
class VolitileStore extends n3_1.Store {
    getQuadsOnce(s, p, o, g) {
        const quads = this.getQuads(s, p, o, g);
        this.removeQuads(quads);
        return quads;
    }
    getSubjectsOnce(p, o, g) {
        return this.getQuadsOnce(null, p, o, g).map((term) => term.subject);
    }
    getObjectsOnce(s, p, g) {
        return this.getQuadsOnce(s, p, null, g).map((term) => term.object);
    }
}
exports.default = VolitileStore;
